export default [
  {
    title: 'breadcrumb.administrator',
    route: 'list-administrator',
    icon: 'UserIcon',
    resource: 'administrator',
    action: 'read'
  }
];